module.exports = __webpack_public_path__ + "static/media/ios-images.d7f458e4.svg";